<template>
  <BaseModal
    :parentRoute="
      parentRouteName
        ? {
            name: parentRouteName
          }
        : undefined
    "
    useForm
    :loading="loading"
    :noPadding="noPadding"
    :heading="$t('integrations.settings_heading')"
    :small="small"
    @submit="$emit('submit')"
    @close="$emit('close')"
  >
    <slot />
    <template #footer>
      <BaseButton
        color="inverted"
        :routerLink="{
          name: parentRouteName
        }"
        @click="$emit('close')"
        v-test="'integration-cancel'"
      >
        {{ $t('global.actions.cancel') }}
      </BaseButton>
      <BaseButton
        submitForm
        :loading="saving"
        v-test="'integration-save'"
      >
        {{ $t('global.actions.save') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
defineProps<{
  loading?: boolean;
  noPadding?: boolean;
  parentRouteName: string;
  saving?: boolean;
  small?: boolean;
}>();

defineEmits(['submit', 'close']);
</script>
